export default "__VITE_ASSET__3f0093fa__"